const psGridItemList = document.querySelectorAll('.product-solutions-gallery .grid-item');
if (psGridItemList.length > 0) {
  const hidden = 'modal-hidden';
  [].map.call(psGridItemList, (gridItem) => {
    const modal = gridItem.nextElementSibling;
    const btns = modal.querySelectorAll('.close-button, .back-btn');

    gridItem.addEventListener('click', () => {
      if (modal.classList.contains(hidden)) {
        modal.classList.toggle(hidden);
      }
    });

    [].map.call(btns, (btn) => {
      btn.addEventListener('click', () => {
        modal.classList.toggle(hidden);
      });
    });

    document.addEventListener('keydown', (e) => {
      if (!modal.classList.contains(hidden) && e.key === 'Escape') {
        modal.classList.toggle(hidden);
      }
    });
  });
}
